export default "__VITE_ASSET__BAZSn3mq__"